<div class="chat-prop">
  <div class="chat-prop__photo">
    <img *ngIf="property.image && !imageFailed" [src]="property.image" alt="" loading="lazy" (error)="imageFailed = true">
    <span *ngIf="!property.image || imageFailed" class="chat-prop__placeholder"><chat-icon name="home" [size]="26"></chat-icon></span>
    <div class="chat-prop__pills">
      <span *ngIf="businessTypeText" class="chat-prop__pill chat-prop__pill--type">{{ businessTypeText }}</span>
      <span *ngIf="statusText" class="chat-prop__pill" [ngClass]="'chat-prop__pill--' + statusTone">{{ statusText }}</span>
    </div>
  </div>
  <div class="chat-prop__body">
    <div class="chat-prop__top">
      <span *ngIf="property.reference" class="chat-prop__ref">{{ property.reference }}</span>
      <span class="chat-prop__price" [class.chat-prop__price--muted]="!price">{{ price || strings.priceOnRequest }}</span>
    </div>
    <div *ngIf="property.title" class="chat-prop__title">{{ property.title }}</div>
    <div *ngIf="property.location" class="chat-prop__where">{{ property.location }}</div>
    <ul *ngIf="facts.length > 0" class="chat-prop__facts" aria-label="">
      <li *ngFor="let f of facts" class="chat-prop__fact">
        <chat-icon [name]="f.icon" [size]="13"></chat-icon>{{ f.text }}
      </li>
    </ul>
    <div class="chat-prop__actions">
      <a *ngIf="property.route" class="chat-prop__btn chat-prop__btn--primary" [routerLink]="property.route" [queryParams]="property.queryParams">
        {{ strings.seeDetails }}
      </a>
      <a *ngIf="!property.route && property.link" class="chat-prop__btn chat-prop__btn--primary" [href]="property.link" target="_blank" rel="noopener">
        {{ strings.seeDetails }}
      </a>
      <button *ngIf="canScheduleVisit" type="button" class="chat-prop__btn chat-prop__btn--light" (click)="scheduleVisit.emit(property)">
        {{ strings.scheduleVisit }}
      </button>
    </div>
  </div>
</div>
